import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../hooks/UserContext';
import { UserRole } from '../types/user';

export const getHomeRoute = (role: UserRole | undefined): string => {
  const managerialRoles: UserRole[] = ['OWNER', 'MANAGER', 'OFFICE_ADMIN'];
  if (!role) return '/login';
  return managerialRoles.includes(role) ? '/dashboard' : '/my-tasks';
};

interface ProtectedRouteProps {
  allowedRoles?: UserRole[];
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ allowedRoles }) => {
  const { user, isLoading } = useAuth();

  if (isLoading) {
    return <div>Loading...</div>;
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (allowedRoles && !allowedRoles.includes(user.role)) {
    return <Navigate to="/" replace />;
  }

  return <Outlet />;
};

export default ProtectedRoute;